// extracted by mini-css-extract-plugin
export default {"container":"Tasks_container__MafVO","task":"Tasks_task__J5IWj","photo":"Tasks_photo__TTsRL","content":"Tasks_content__blC6m","tasks":"Tasks_tasks__5IUMY"};